import { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/16/solid';
import {
  ArrowPathRoundedSquareIcon,
  Cog6ToothIcon,
  CurrencyPoundIcon,
  UserIcon,
  CalendarDaysIcon,
  BellIcon,
  UserGroupIcon,
} from '@heroicons/react/20/solid';
import UsersManager from './usersmanager';
import Logins from './logins';
import ManagerNav from './managernav';
import Visitors from './visitors';


const tabs = [
  { name: 'User Sessions', component: <Logins/>, icon: BellIcon },
  { name: 'Users', component: <UsersManager />, icon: UserIcon },
  { name: 'Visitors', component: <Visitors />, icon: UserGroupIcon },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Example() {
  const [currentTabIndex, setCurrentTabIndex] = useState(1); // Default to the first tab index

  const handleTabChange = (index) => {
    setCurrentTabIndex(index);
  };

  return (
    <div data-component="manager-user-home">
        <ManagerNav />
      <div className="grid grid-cols-1 sm:hidden">
        {/* Mobile version - dropdown to select a tab */}
        <select
          data-component="manager-user-home-select"
          value={tabs[currentTabIndex].name}
          onChange={(e) => {
            const selectedTab = tabs.find((tab) => tab.name === e.target.value);
            const index = tabs.indexOf(selectedTab);
            handleTabChange(index);
          }}
          aria-label="Select a tab"
          className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
        >
          {tabs.map((tab) => (
            <option key={tab.name} value={tab.name}>
              {tab.name}
            </option>
          ))}
        </select>
        <ChevronDownIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500"
        />
      </div>

      <div className="hidden sm:block">
        {/* Desktop version - horizontal tab navigation */}
        <div className="border-b border-gray-200">
          <nav aria-label="Tabs" className="-mb-px flex space-x-8 overflow-x-auto justify-center">
            {tabs.map((tab, index) => (
              <button
                key={tab.name}
                data-component="manager-user-home-tab"
                data-feature={tab.name.replace(/\s+/g, '-').toLowerCase()}
                onClick={() => handleTabChange(index)} // Handle tab switch
                className={classNames(
                  currentTabIndex === index
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                  'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium',
                )}
              >
                {tab.name}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Render the content of the selected tab */}
      <div className="mt-4">{tabs[currentTabIndex].component}</div>
    </div>
  );
}
